import { translate } from '@/domains/core/localization/translate';
export const {
  outOfStock
} = translate({
  "outOfStock": "Oh, you've grabbed the last item in stock!"
});